/**
 * RedirectWithSubpath — redireciona preservando o restante do path.
 *
 * Uso: <Route path="processos/*" element={<RedirectWithSubpath baseTo="/dashboard/juridica/processos" />} />
 *
 * /dashboard/processos/abc-123/andamentos → /dashboard/juridica/processos/abc-123/andamentos
 */
import { Navigate, useParams, useLocation } from "react-router-dom";

interface RedirectWithSubpathProps {
  /** Novo prefixo de destino (sem trailing slash) */
  baseTo: string;
}

const RedirectWithSubpath = ({ baseTo }: RedirectWithSubpathProps) => {
  const { "*": splat } = useParams();
  const location = useLocation();
  const target = splat ? `${baseTo}/${splat}` : baseTo;
  return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
};

export default RedirectWithSubpath;
